import { LoginStatus } from "@/common/constant";
import { setStorage } from "@/utils/storage";
import { mpx } from "@didi/es-mpx-creator";
import {
  query,
  hashQuery,
} from '@didi/webx-js'

const fail = {
  status: LoginStatus.LOGIN_FAIL,
  phone: "",
  token: "",
  uid: 0,
};

const logout = {
  status: LoginStatus.LOGOUT,
  phone: "",
  token: "",
  uid: 0,
};

const mutation = {
  setHomeLoginTipStatus(state, status) {
    state.homeLoginTipVisible = status
  },
  setUserAccountStatus(state, status) {
    state.userAccountStatus = status;
  },
  setUserAccountList(state, list = []) {
    state.userAccountList = list;
  },
  setAccountChannel(state, payload) {
    state.accountChannel = payload
  },
  loginSuccess(state, { phone, token, uid, timeStamp }) {
    state.login = {
      status: LoginStatus.LOGIN_SUC,
      phone,
      token,
      uid,
      timeStamp,
    };
    setStorage({
      key: "login-ticket",
      data: token,
    });
    setStorage({
      key: "phone",
      data: phone,
    });
  },

  loginFail(state) {
    state.login = Object.assign({}, fail);
    setStorage({
      key: "login-ticket",
      data: "",
    });
  },

  logout(state) {
    state.login = Object.assign({}, logout);
    setStorage({
      key: "login-ticket",
      data: "",
    });
  },
  login12306(state, { code, data, message, options }) {
    if (code === '0') {
      state.is12306Login = 1 // 更新填单页状态
      setStorage({
        key: '12306_login_status_for_contacts_page',
        data: 1,
      })
    }
    if (["0", "10607", "10602", "10603", "10610"].includes(code)) {
      const config = {
        phone: data?.phone,
        account: data?.account || options?.account,
        password: data?.password || options?.password,
        code,
        tips: data?.tips || "",
        message,
        account_with_star: data?.account_with_star || options?.account_with_star,
        type: options?.type || 0,
        cxvip: data?.cxVip || data?.cxvip || false
      }
      state.userInfo12306 = config;
      setStorage({
        key: "userInfo12306",
        data: config,
      });
    }
  },
  setChangeCode(state, payload) {
    state.userInfo12306 = { ...state.userInfo12306, ...payload };
    setStorage({
      key: "userInfo12306",
      data: state.userInfo12306,
    })
    if (payload?.isSmsCode) {
      state.isSmsCode = payload.isSmsCode;
      setStorage({
        key: "isSmsCode",
        data: payload?.isSmsCode,
      });
    }
  },

  // sendCaptchaResult

  sendCaptchaResult(state, { code, data, success }) {
    state.retrievalCode = code;
  },

  faceVerification(state, payload) {
    const { code } = payload;
    state.faceVerificaStatus = code === "0" ? true : false;
  },
  quiet(state, { code, data, success }) {
    state.userInfo12306 = {
      phone: data?.phone,
      account: data?.account,
      password: data?.password,
      code,
      account_with_star: data?.account_with_star
    };
  },

  setChangeUserStatus(state, payload) {
    state.changeUserStatus = payload;
  },

  backPageUrlMutation(state, payload) {
    state.fullPath = payload;
    setStorage({ key: "backPageUrl", data: payload });
  },

  requestIdMutation(state, payload) {
    state.request_id = payload.request_id;
  },

  accountInfo12306(state, payload) {
    // state.code = payload.code;
    state.accountInfo12306 = {
      id_no: payload.id_no,
      id_type: payload.id_type,
    };
    setStorage({
      key: "accountInfo12306",
      data: {
        id_no: payload.id_no,
        id_type: payload.id_type,
      },
    });
  },
  clearInfo12306(state) {
    state.userAccountStatus = false
    state.userInfo12306 = null
    mpx.removeStorage({ key: "userInfo12306" })
  },
  pagePathAction(state, payload) {
    const { path, query } = payload;
    let _str = "";
    for (let o in query) {
      _str += o + "=" + query[o] + "&";
    }
    const str = _str ? `?${_str.substring(0, _str.length - 1)}` : "";
    state.fullPath = `${path}${str}`;
  },
  setIs12306Login(state, payload) {
    state.is12306Login = payload
    setStorage({
      key: '12306_login_status_for_contacts_page',
      data: payload,
    })
  },

  setReverseData(state, payload) {
    state.reverseData = payload
  },
  closeCxvipPopup(state) {
    state.cxvipPopupShow = false
  },
  clearCxvipPopupCloseCb(state) {
    state.cxvipPopupCloseCb = null
  },
  checkCxvipPupup(state, payload) {
    const queryParams = {
      ...query(),
      ...hashQuery()
    }
    const loginStatus = state.userInfo12306?.account_with_star
    const cxvip = state.userInfo12306?.cxvip
    if (queryParams.cxvip === 'popup' && loginStatus && !cxvip) {
      state.cxvipPopupShow = true
      state.cxvipPopupCloseCb = payload?.closeCb || null
    } else {
      state.cxvipPopupShow = false
      state.cxvipPopupCloseCb = null
      payload?.closeCb && payload?.closeCb()
    }
  },
  verifyCxvip(state, stauts) {
    state.cxvipVerify = stauts
  },
  setShowLoginDrawer(state, payload) {
    state.showLoginDrawer = payload
  }
};

export default mutation;
